import { DefaultService as AssetsSDK } from '@atbay/asset-service-node-sdk'
import { createClient } from '@core/base/http-client'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const AssetsClient = createClient(AssetsSDK)
